<template>
  <div>
  </div>
</template>

<script>
import { router } from '@/routes';
import { logout } from '@/helpers/UserAPI';
export default {
  name: 'Logout',
  created() {
    logout();
    router.push('/');
  }
}
</script>